import {Component, Inject} from '@angular/core';
import {SuppliersService} from '../../../../services/suppliers.service';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'ps-commission-bottomsheet',
  templateUrl: 'commission.bottomsheet.component.html'
})
export class CommissionBottomsheetComponent {

  commissionNr: string;

  constructor(private suppliersService: SuppliersService, private bs: MatBottomSheetRef<CommissionBottomsheetComponent>,
              @Inject(MAT_BOTTOM_SHEET_DATA) public objId: string) {
  }

  save() {
    this.suppliersService.setCommissionNr(this.objId, this.commissionNr).subscribe(result => {
      this.bs.dismiss(result);
    });
  }

  dismiss() {
    this.bs.dismiss();
  }
}
